// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_1jKw6","triggerList":"_1Cy8Q","dropdown":"tbnOk","dropdownContent":"_3sxKR"};